import CSV from 'icons/csvIcon.svg';
import DOCX from 'icons/docIcon.svg';
import FILE from 'icons/fileIcon.svg';
import JPG from 'icons/jpgIcon.svg';
import PDF from 'icons/pdfIcon.svg';
import PNG from 'icons/pngIcon.svg';
import PPT from 'icons/pptIcon.svg';
import TXT from 'icons/txtIcon.svg';
import XLS from 'icons/xlsIcon.svg';
import ZIP from 'icons/zipIcon.svg';

export const INSTANCE_DOMAIN_URL = 'https://agents.engati.ai';

export const ENGATI_ICON_URL = 'https://s3.ap-south-1.amazonaws.com/branding-resources/images/engt.gif';

export const ENGATI_URL = 'https://www.engati.ai';

export const LIBRARY = {
	RECORDER:
		'https://s3.ap-south-1.amazonaws.com/branding-resources/bot_files/prod/1.0.0/mediaStreamRecoder/1.0.0/mediaStreamRecoder.js',
};

export const ENGT_ID = {
	UNREAD_COUNT_BADGE: 'unreadCountLaunchScreen',
	UNREAD_NOTIFICATION_BADGE: 'unreadNotificationBadge',
};

export const CSS_COLORS = {
	THEME_COLOR: 'var(--engt-theme-color)',
	THEME_TEXT_COLOR: 'var(--engt-theme-text-color)',
	ENGT_RED: 'var(--engt-red)',
	ENGT_BORDER_COLOR: 'var(--engt-input-border-color)',
};

export const ALLOWED_ATTACHMENT_TYPES =
	'.doc, .docx, .xls, .xlsx, .ppt, .pptx, .xps, .pdf, .ai, .psd, .dxf, .eps, .ps, .svg, .ttf, .zip, .rar, .tar, .gzip, .mp3, .mpeg, .wav, .ogg, .jpeg, .jpg, .png, .gif, .bmp, .tif, .webm, .mp4, .mpeg4, .3gpp, .mov, .avi, .mpegps, .wmv, .flv, .txt, .csv, .tsv, image/jpg;capture=camera';

export const ALLOWED_VIDEO_FILE_EXTENSIONS = [
	'mp4',
	'm4v',
	'mov',
	'mpeg',
	'mpg',
	'webm',
	'3gp',
	'3gpp',
	'3g2',
	'3gpp2',
	'avi',
];

export const ALLOWED_FILE_EXTENSIONS = [
	'doc',
	'docx',
	'pdf',
	'jpg',
	'jpeg',
	'png',
	'zip',
	...ALLOWED_VIDEO_FILE_EXTENSIONS,
];

export const ALLOWED_VIDEO_FILE_TYPES = ALLOWED_VIDEO_FILE_EXTENSIONS.map((extension) => `.${extension}`).join(', ');

export const ALLOWED_FILE_TYPES = ALLOWED_FILE_EXTENSIONS.map((extension) => `.${extension}`).join(', ');

export const ALLOWED_ATTACHMENT_SIZE = 26214400; // 25MB

export const ALLOWED_FILE_SIZE = 5242880; // 5MB

export const ALLOWED_VIDEO_FILE_SIZE = ALLOWED_ATTACHMENT_SIZE; // 25MB

export const BASE_FILE_TYPE_IMG_URL = 'https://branding-resources.s3.ap-south-1.amazonaws.com/default/portal/bot-icons';

export const OTHER_FILE_TYPE = `${BASE_FILE_TYPE_IMG_URL}/engt_file.svg`;

export const SESSION_EXP_TIME = 20 * 60 * 1000;

export const DELAY_CALLOUT_WITH_ANIMATION_TIME = 0.6;

export const LAUNCHER_IMG_ERROR_FALLBACK =
	'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=2000'; // to be replaced with s3 url after uploaded

export const HEADER_IMG_ERROR_FALLBACK =
	'https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?w=2000'; // to be replaced with s3 url after uploaded

export const BROWSER_AGENT_REGEX =
	/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;

export const BROWSER_AGENT_REGEX_TYPE =
	// eslint-disable-next-line no-useless-escape
	/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

export const GENERIC_STRINGS = {
	SELECT_AN_OPTION: 'Select an option...',
	BROWSE_FILE_TO_UPLOAD: 'Browse and select a file',
	CHAT_CLOSURE_MESSAGE: 'Oops! Session timed out!',
	SUBMIT: 'Submit',
	GO_BACK_TO_CONVERSATION: 'Go back to conversation',
	CONTINUE: 'Continue',
	INVALID_INPUT: 'Invalid Input',
	SEND_A_MESSAGE: 'Send a Message',
	OK: 'Ok',
	CANCEL: 'Cancel',
	DID_THIS_ANSWER_HELP: 'Did this answer help?',
	DEFAULT_ERROR_MESSAGE: 'Something went wrong. Please try again or get in touch with the administrator',
	YES: 'Yes',
	NO: 'No',
	PLACE_HOLDER_START_TYPING_TO_FILTER: 'Start typing to filter..',
	PLACE_HOLDER_PICK_A_DATE: 'Pick a Date',
	PLACE_HOLDER_WRITE_A_REPLY: 'Write a reply...',
	FEEDBACK_NODE_SELECTION_MESSAGE: 'You Selected :',
	START_CALL_BUTTON: 'Start the call',
	START_CALL_TEXT: 'Start call with',
	VIDEO_JOINING_TEXT: 'You are joining as',
	VIDEO_CHAT_CLOSE_TOOLTIP: 'Chat with everyone',
	VIDEO_CHAT_OPEN_TOOLTIP: 'Close chat',
	VIDEO_MICROPHONE_OFF_TOOLTIP: 'Turn on microphone',
	VIDEO_MICROPHONE_ON_TOOLTIP: 'Turn off microphone',
	VIDEO_CAMERA_OFF_TOOLTIP: 'Turn on camera',
	VIDEO_CAMERA_ON_TOOLTIP: 'Turn off camera',
	VIDEO_SCREENSHARE_ON_TOOLTIP: 'Stop presenting',
	VIDEO_SCREENSHARE_OFF_TOOLTIP: 'Present now',
	VIDEO_SCREENSHARE_DISABLE_TOOLTIP: 'is presenting',
	VIDEO_LEAVE_CALL_TOOLTIP: 'Leave call',
	VIDEO_REJOIN: 'Rejoin',
	VIDEO_LEFT_CALL: 'You have left the video call.',
	VIDEO_END_CALL: 'Your video call has ended.',
	VIDEO_CLOSE: 'Close',
	CHARACTER_LIMIT_EXCEEDED: 'Character limit of 15000 exceeded',
	HTML_TAG_NOT_ALLOWED: 'ERROR: No HTML Tag Allowed',
};

export const GENERIC_STRINGS_ARRAY = [
	'SETTINGS.SELECT_AN_OPTION',
	'SETTINGS.BROWSE_FILE_TO_UPLOAD',
	'SETTINGS.LAUNCH.AGENT_ARE_ONLINE',
	'SETTINGS.LAUNCH.AGENT_IS_ONLINE',
	'SETTINGS.LAUNCH.START_A_NEW_CONVO',
	'SETTINGS.LAUNCH.PREVIEW_HEADER',
	'SETTINGS.SUBMIT',
	'SETTINGS.CONTINUE',
	'SETTINGS.INVALID_INPUT',
	'SETTINGS.PICK_A_DATE',
	'SETTINGS.START_TYPING_TO_FILTER',
	'SETTINGS.WRITE_A_REPLY',
	'SETTINGS.SEND_A_MESSAGE',
	'SETTINGS.OK',
	'SETTINGS.CANCEL',
	'SETTINGS.DID_THIS_ANSWER_HELP',
	'SETTINGS.DEFAULT_ERROR_MESSAGE',
	'SETTINGS.YES',
	'SETTINGS.NO',
	'SETTINGS.GO_BACK_TO_CONVERSATION',
	'SETTINGS.FEEDBACK_NODE_SELECTION_MESSAGE',
	'SETTINGS.CHAT_CLOSURE_MESSAGE',
	'SETTINGS.START_CALL_BUTTON',
	'SETTINGS.START_CALL_TEXT',
	'SETTINGS.VIDEO_JOINING_TEXT',
	'SETTINGS.VIDEO_CHAT_CLOSE_TOOLTIP',
	'SETTINGS.VIDEO_CHAT_OPEN_TOOLTIP',
	'SETTINGS.VIDEO_MICROPHONE_OFF_TOOLTIP',
	'SETTINGS.VIDEO_MICROPHONE_ON_TOOLTIP',
	'SETTINGS.VIDEO_CAMERA_OFF_TOOLTIP',
	'SETTINGS.VIDEO_CAMERA_ON_TOOLTIP',
	'SETTINGS.VIDEO_SCREENSHARE_ON_TOOLTIP',
	'SETTINGS.VIDEO_SCREENSHARE_OFF_TOOLTIP',
	'SETTINGS.VIDEO_SCREENSHARE_DISABLE_TOOLTIP',
	'SETTINGS.VIDEO_LEAVE_CALL_TOOLTIP',
	'SETTINGS.VIDEO_REJOIN',
	'SETTINGS.VIDEO_LEFT_CALL',
	'SETTINGS.VIDEO_END_CALL',
	'SETTINGS.VIDEO_CLOSE',
	'SETTINGS.POP_UP_MESSAGE',
	'SETTINGS.LAUNCH.GO_BACK_TO_CONVERSATION',
	'SETTINGS.CHAT_SETTINGS',
	'SETTINGS.CLEAR_CHAT_HISTORY',
	'SETTINGS.READ_MORE',
	'SETTINGS.EXPLORE_MORE',
	'SETTINGS.CONFIRM',
	'SETTINGS.CHOOSE_LANGUAGE',
	'SETTINGS.START_CONVERSATION_PROMPT',
	'SETTINGS.CONTINUE_CONVERSATION',
	'SETTINGS.SESSION_TIMEOUT',
	'SETTINGS.TYPING',
	'SETTINGS.CLEAR_CHAT_HISTORY',
	'SETTINGS.FONT_SIZE',
	'SETTINGS.LANGUAGE_PREFERENCE',
	'SETTINGS.SELECT_FONT',
	'SETTINGS.SMALL_FONT',
	'SETTINGS.DEFAULT_FONT',
	'SETTINGS.MEDIUM_FONT',
	'SETTINGS.LARGE_FONT',
	'SETTINGS.CLOSE_CHAT_PROMPT',
	'SETTINGS.CLOSE_CHAT',
	'SETTINGS.START_NEW_CONVERSATION',
	'SETTINGS.CONTINUE_CONVERSATION',
	'SETTINGS.EXIT_AGENT_CONVERSATION',
	'SETTINGS.SKIP',
	'SETTINGS.EDIT',
	'SETTINGS.UPLOAD',
	'SETTINGS.PLACEHOLDER.FILL_DETAILS',
	'SETTINGS.PLACEHOLDER.SELECT',
	'SETTINGS.PLACEHOLDER.ENTER',
	'SETTINGS.CHARACTER_LIMIT_EXCEEDED',
	'SETTINGS.HTML_TAG_NOT_ALLOWED',
	'SETTINGS.FORM_SUBMIT',
	'SETTINGS.FORM_SKIP',
	'SETTINGS.DROP_YOUR_FILES',
	'SETTINGS.FILE_SIZE',
	'SETTINGS.FILE_UPLOAD_VIDEO_SIZE_INFO',
	'SETTINGS.FILE_UPLOAD_FILE_SIZE_ERROR',
	'SETTINGS.FILE_UPLOAD_VIDEO_SIZE_ERROR',
	'SETTINGS.FILE_UPLOAD_INVALID_SIZE_ERROR',
	'SETTINGS.FILE_BROWSE',
	'SETTINGS.GIVE_FEEDBACKS',
	'SETTINGS.RUD_PASSWORD.RETRIGGER_BUTTON_NAME',
	'SETTINGS.THINKING',
];
export const IGNORE_TYPES_FOR_LS = ['typing_indicator', 'ASK_USER_NAME', 'UPDATE_LIVECHAT_STATUS'];

export const DEFAULT_EDIT_RESPONSE = 'I want to change the answer';

export const LS_STORAGE_LIMIT = 10;

export const TIMESTAMP_EXCLUDED_MSG_TYPES = ['divider'];

export const FILE_ICONS = {
	DOCX,
	FILE,
	CSV,
	JPG,
	PNG,
	PDF,
	PPT,
	XLS,
	TXT,
	ZIP,
};

export const NOTIFICATION_AUDIO = new Audio(
	'https://branding-resources.s3.ap-south-1.amazonaws.com/default/bot/bot-livechat.mp3'
);

export const KEY_CODES = {
	ENTER: 13,
	ESC: 27,
	UP: 38,
	DOWN: 40,
	TAB: 9,
};

export const OPTIONS_SRC_NODE_NAMES = ['SEND_MSG_OPTNS', 'TRIGGER_LIVECHAT', 'JSON_API'];
export const REGEX_EQUATION_TO_CHECK_FOR_HTML_TAG =
	/<!DOCTYPE html>|<\/?[a-zA-Z][^>]*>|<(?=[a-zA-Z])[^>\s]*[^>]*(on\w+\s*=\s*["'][^"']*["']|javascript:|$)|(\&(?:[\w\d]+|#\d+|#x[a-f\d]+);)/;
export const MAX_CHARACTER_LIMIT = 15000;
export const FILE_TYPE = {
	AUDIO: 'audio',
	VIDEO: 'video',
};
export const REGEX_EQUAION_TO_CHECK_FOR_LINKS = /<a[^>]+href="([^"]+)"/;
export const VIMEO_REGEX =
	/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
export const YOUTUBE_REGEX =
	/^http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gm;
export const FACEBOOK_REGEX =
	/(?:https?:\/\/)?(?:www.|web.|m.)?(facebook|fb).(com|watch)\/(?:video.php\?v=\d+|(\S+)|photo.php\?v=\d+|\?v=\d+)|\S+\/videos\/((\S+)\/(\d+)|(\d+))\/?/;
export const VIDEO_REGEX =
	/^(http[s]?:\/\/)?([^:\/\s]+)(:([^\/]*))?(\/\w+\.)*([^#?\s]+)(\?([^#]*))?(\.[mM][pP]4|\.[mM][kK][vV])$/gm;

export const COUNTRY_CODES = {
	'+1': '+1',
	'+7': '+7',
	'+20': '+20',
	'+27': '+27',
	'+30': '+30',
	'+31': '+31',
	'+32': '+32',
	'+33': '+33',
	'+34': '+34',
	'+36': '+36',
	'+39': '+39',
	'+40': '+40',
	'+41': '+41',
	'+43': '+43',
	'+44': '+44',
	'+45': '+45',
	'+46': '+46',
	'+47': '+47',
	'+48': '+48',
	'+49': '+49',
	'+51': '+51',
	'+52': '+52',
	'+53': '+53',
	'+54': '+54',
	'+55': '+55',
	'+56': '+56',
	'+57': '+57',
	'+58': '+58',
	'+60': '+60',
	'+61': '+61',
	'+62': '+62',
	'+63': '+63',
	'+64': '+64',
	'+65': '+65',
	'+66': '+66',
	'+81': '+81',
	'+82': '+82',
	'+84': '+84',
	'+86': '+86',
	'+90': '+90',
	'+91': '+91',
	'+92': '+92',
	'+94': '+94',
	'+95': '+95',
	'+98': '+98',
	'+212': '+212',
	'+213': '+213',
	'+216': '+216',
	'+218': '+218',
	'+220': '+220',
	'+221': '+221',
	'+222': '+222',
	'+223': '+223',
	'+224': '+224',
	'+226': '+226',
	'+227': '+227',
	'+228': '+228',
	'+229': '+229',
	'+231': '+231',
	'+232': '+232',
	'+233': '+233',
	'+234': '+234',
	'+236': '+236',
	'+237': '+237',
	'+238': '+238',
	'+239': '+239',
	'+240': '+240',
	'+241': '+241',
	'+242': '+242',
	'+244': '+244',
	'+245': '+245',
	'+248': '+248',
	'+249': '+249',
	'+250': '+250',
	'+251': '+251',
	'+252': '+252',
	'+253': '+253',
	'+254': '+254',
	'+256': '+256',
	'+257': '+257',
	'+258': '+258',
	'+260': '+260',
	'+261': '+261',
	'+262': '+262',
	'+263': '+263',
	'+264': '+264',
	'+265': '+265',
	'+266': '+266',
	'+267': '+267',
	'+268': '+268',
	'+269': '+269',
	'+290': '+290',
	'+291': '+291',
	'+297': '+297',
	'+298': '+298',
	'+299': '+299',
	'+350': '+350',
	'+351': '+351',
	'+352': '+352',
	'+353': '+353',
	'+354': '+354',
	'+356': '+356',
	'+357': '+357',
	'+358': '+358',
	'+359': '+359',
	'+370': '+370',
	'+371': '+371',
	'+372': '+372',
	'+373': '+373',
	'+374': '+374',
	'+375': '+375',
	'+376': '+376',
	'+377': '+377',
	'+378': '+378',
	'+379': '+379',
	'+380': '+380',
	'+381': '+381',
	'+385': '+385',
	'+386': '+386',
	'+387': '+387',
	'+389': '+389',
	'+417': '+417',
	'+420': '+420',
	'+421': '+421',
	'+500': '+500',
	'+501': '+501',
	'+502': '+502',
	'+503': '+503',
	'+504': '+504',
	'+505': '+505',
	'+506': '+506',
	'+507': '+507',
	'+509': '+509',
	'+590': '+590',
	'+591': '+591',
	'+592': '+592',
	'+593': '+593',
	'+594': '+594',
	'+595': '+595',
	'+596': '+596',
	'+597': '+597',
	'+598': '+598',
	'+670': '+670',
	'+671': '+671',
	'+672': '+672',
	'+673': '+673',
	'+674': '+674',
	'+675': '+675',
	'+676': '+676',
	'+677': '+677',
	'+678': '+678',
	'+679': '+679',
	'+680': '+680',
	'+681': '+681',
	'+682': '+682',
	'+683': '+683',
	'+686': '+686',
	'+687': '+687',
	'+688': '+688',
	'+689': '+689',
	'+691': '+691',
	'+692': '+692',
	'+850': '+850',
	'+852': '+852',
	'+853': '+853',
	'+855': '+855',
	'+856': '+856',
	'+880': '+880',
	'+886': '+886',
	'+960': '+960',
	'+961': '+961',
	'+962': '+962',
	'+963': '+963',
	'+964': '+964',
	'+965': '+965',
	'+966': '+966',
	'+967': '+967',
	'+968': '+968',
	'+969': '+969',
	'+971': '+971',
	'+972': '+972',
	'+973': '+973',
	'+974': '+974',
	'+975': '+975',
	'+976': '+976',
	'+977': '+977',
	'+992': '+992',
	'+993': '+993',
	'+994': '+994',
	'+996': '+996',
	'+998': '+998',
	'+1242': '+1242',
	'+1246': '+1246',
	'+1264': '+1264',
	'+1268': '+1268',
	'+1345': '+1345',
	'+1441': '+1441',
	'+1473': '+1473',
	'+1649': '+1649',
	'+1664': '+1664',
	'+1758': '+1758',
	'+1787': '+1787',
	'+1809': '+1809',
	'+1868': '+1868',
	'+1869': '+1869',
	'+1876': '+1876',
	'+7880': '+7880',
};

export const RUD_COUNTRY_CODES = {
	'+91': '+91',
	'+1': '+1',
	'+7': '+7',
	'+20': '+20',
	'+27': '+27',
	'+30': '+30',
	'+31': '+31',
	'+32': '+32',
	'+33': '+33',
	'+34': '+34',
	'+36': '+36',
	'+39': '+39',
	'+40': '+40',
	'+41': '+41',
	'+43': '+43',
	'+44': '+44',
	'+45': '+45',
	'+46': '+46',
	'+47': '+47',
	'+48': '+48',
	'+49': '+49',
	'+51': '+51',
	'+52': '+52',
	'+53': '+53',
	'+54': '+54',
	'+55': '+55',
	'+56': '+56',
	'+57': '+57',
	'+58': '+58',
	'+60': '+60',
	'+61': '+61',
	'+62': '+62',
	'+63': '+63',
	'+64': '+64',
	'+65': '+65',
	'+66': '+66',
	'+81': '+81',
	'+82': '+82',
	'+84': '+84',
	'+86': '+86',
	'+90': '+90',
	'+92': '+92',
	'+94': '+94',
	'+95': '+95',
	'+98': '+98',
	'+212': '+212',
	'+213': '+213',
	'+216': '+216',
	'+218': '+218',
	'+220': '+220',
	'+221': '+221',
	'+222': '+222',
	'+223': '+223',
	'+224': '+224',
	'+226': '+226',
	'+227': '+227',
	'+228': '+228',
	'+229': '+229',
	'+231': '+231',
	'+232': '+232',
	'+233': '+233',
	'+234': '+234',
	'+236': '+236',
	'+237': '+237',
	'+238': '+238',
	'+239': '+239',
	'+240': '+240',
	'+241': '+241',
	'+242': '+242',
	'+244': '+244',
	'+245': '+245',
	'+248': '+248',
	'+249': '+249',
	'+250': '+250',
	'+251': '+251',
	'+252': '+252',
	'+253': '+253',
	'+254': '+254',
	'+256': '+256',
	'+257': '+257',
	'+258': '+258',
	'+260': '+260',
	'+261': '+261',
	'+262': '+262',
	'+263': '+263',
	'+264': '+264',
	'+265': '+265',
	'+266': '+266',
	'+267': '+267',
	'+268': '+268',
	'+269': '+269',
	'+290': '+290',
	'+291': '+291',
	'+297': '+297',
	'+298': '+298',
	'+299': '+299',
	'+350': '+350',
	'+351': '+351',
	'+352': '+352',
	'+353': '+353',
	'+354': '+354',
	'+356': '+356',
	'+357': '+357',
	'+358': '+358',
	'+359': '+359',
	'+370': '+370',
	'+371': '+371',
	'+372': '+372',
	'+373': '+373',
	'+374': '+374',
	'+375': '+375',
	'+376': '+376',
	'+377': '+377',
	'+378': '+378',
	'+379': '+379',
	'+380': '+380',
	'+381': '+381',
	'+385': '+385',
	'+386': '+386',
	'+387': '+387',
	'+389': '+389',
	'+417': '+417',
	'+420': '+420',
	'+421': '+421',
	'+500': '+500',
	'+501': '+501',
	'+502': '+502',
	'+503': '+503',
	'+504': '+504',
	'+505': '+505',
	'+506': '+506',
	'+507': '+507',
	'+509': '+509',
	'+590': '+590',
	'+591': '+591',
	'+592': '+592',
	'+593': '+593',
	'+594': '+594',
	'+595': '+595',
	'+596': '+596',
	'+597': '+597',
	'+598': '+598',
	'+670': '+670',
	'+671': '+671',
	'+672': '+672',
	'+673': '+673',
	'+674': '+674',
	'+675': '+675',
	'+676': '+676',
	'+677': '+677',
	'+678': '+678',
	'+679': '+679',
	'+680': '+680',
	'+681': '+681',
	'+682': '+682',
	'+683': '+683',
	'+686': '+686',
	'+687': '+687',
	'+688': '+688',
	'+689': '+689',
	'+691': '+691',
	'+692': '+692',
	'+850': '+850',
	'+852': '+852',
	'+853': '+853',
	'+855': '+855',
	'+856': '+856',
	'+880': '+880',
	'+886': '+886',
	'+960': '+960',
	'+961': '+961',
	'+962': '+962',
	'+963': '+963',
	'+964': '+964',
	'+965': '+965',
	'+966': '+966',
	'+967': '+967',
	'+968': '+968',
	'+969': '+969',
	'+971': '+971',
	'+972': '+972',
	'+973': '+973',
	'+974': '+974',
	'+975': '+975',
	'+976': '+976',
	'+977': '+977',
	'+992': '+992',
	'+993': '+993',
	'+994': '+994',
	'+996': '+996',
	'+998': '+998',
	'+1242': '+1242',
	'+1246': '+1246',
	'+1264': '+1264',
	'+1268': '+1268',
	'+1345': '+1345',
	'+1441': '+1441',
	'+1473': '+1473',
	'+1649': '+1649',
	'+1664': '+1664',
	'+1758': '+1758',
	'+1787': '+1787',
	'+1809': '+1809',
	'+1868': '+1868',
	'+1869': '+1869',
	'+1876': '+1876',
	'+7880': '+7880',
};
